import { Component, EventEmitter, inject, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, switchMap, tap, map, catchError, of, startWith } from 'rxjs';
import { DataState } from '../../../model/dataState';
import { NavStateService } from '../../../services/nav-state.service';
import { Verification } from '../../../services/verification';
import { Country } from 'country-state-city';
import { DeleteDialog } from '../../common-features/delete-dialog/delete-dialog';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
interface PaginationParams {
  page: number;
  size: number;
  companyName:string;
  country:string;
  sortKey:string;
  sortOrder:string;

}
@Component({
  selector: 'app-canon-list',
  standalone: false,
  templateUrl: './canon-list.html',
  styleUrl: './canon-list.less',
})
export class CanonList {
private verificationService = inject(Verification);
  private navState = inject(NavStateService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  @Output() editCanonItem= new EventEmitter<any>(); 
  pagination$ = new BehaviorSubject<PaginationParams>({ page: 0, size: 10,companyName:'',country:'',sortKey:'',sortOrder:'asc' });
  searchTerm: string = '';
  selectedStatus: string = 'All Statuses';
  selectedDateRange: string = 'Last 30 Days';
  canonList$!: Observable<DataState<any[]>>;
  currentPage = 0;
  countryList = Country.getAllCountries();
  pageSize = 10;
  sortOrder: string = '';
  sortKey: string = '';
  totalPages = 0;
  totalRecord:number = 0;
  start:number = 0;
  end:number = 0;
  pages:any[]=[];
  stats = {
    pending: 34,
    inReview: 18,
    completed: 195,
    spend: 4850
  };
  countrySearchControl = new FormControl('');
  filteredCountries$!: Observable<any[]>;
  constructor() { }

  ngOnInit(): void {
    this.navState.setCurrentTitle('Canon List');
    this.navState.setShowBackButton(false);
    this.canonList$ = this.pagination$.pipe(
      switchMap((params) => {
        this.currentPage = params.page;
        this.pageSize = params.size;
        return this.verificationService.getCanonList(params.page, params.size,params.country,params.companyName,params.sortKey,params.sortOrder).pipe(
          tap((response:any)=>{
            if (response) {
              this.totalRecord = response.total;
              this.totalPages = Math.ceil(response.total / this.pageSize);
              // console.log(this.totalPages)
              this.pages = Array.from({ length: this.totalPages }, (_, i) => i)
              // console.log(this.pages)
               this.start = this.currentPage * this.pageSize +1;
              console.log(this.start)
              this.end = (this.currentPage + 1) * this.pageSize;
              console.log(this.end)
              if (this.end > this.totalRecord){
                this.end = this.totalRecord;
              }
            }
            
          }),
          map((response: any) => ({
            loading: false,
            error: null,
            data: response.result
          }
        )),
          catchError((error) => of({
            loading: false,
            error: error,
            data: null
          })),
          startWith({
            loading: true,
            error: null,
            data: null
          })
        )
      })
    )
    this.filteredCountries$ = this.countrySearchControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCountries(value || ''))
    );
    
    // 4. Pre-fill the input field text if a country filter is active by default
    const initialCountry = this.pagination$.value.country || '';
    this.countrySearchControl.setValue(initialCountry, { emitEvent: false });
  }

  private _filterCountries(value: string): any[] {
    const filterValue = value.toLowerCase().trim();
    
    // Always include the "ALL" option at the top of the search results
    const matches = this.countryList.filter(country => 
      country.name.toLowerCase().includes(filterValue)
    );
    
    return matches;
  }

  startVerificationWorkflow(): void {
    console.log('Routing execution step to Company Details Form component view...');
    this.router.navigate(['/verification/verification-form'],{
      state:{mode:'create'}
    })
  }

  downloadReport(recordId: string): void {
    console.log(`Downloading compiled evaluation sheet or raw certificate for execution packet ${recordId}`);
  }

  onPageChange(newPage: number) {
    if (newPage <0 || newPage >this.totalPages){
      return;
    }
    this.pagination$.next({
      ...this.pagination$.value,
      page: newPage,
      size: this.pageSize,
      
    })
  }

  onSortOrderChange(sortOrder:string){
    this.pagination$.next({
      ...this.pagination$.value,
      sortOrder : sortOrder
      
    })
  }

  onCountryChange(country:string){
     this.pagination$.next({
      ...this.pagination$.value,
      country:country
      
    })
  }

  onSortKeyChange(key:string){
     this.pagination$.next({
      ...this.pagination$.value,
      sortKey:key
      
    })
  }

  onCompanyNameChange(name:string){
    this.pagination$.next({
      ...this.pagination$.value,
      companyName: name

    })
  }

  resetSearch(){
    this.pagination$.next({
     page: 0,
      size: 10,
      companyName: '',
      country: '',
      sortKey: '',
      sortOrder: '',
    })
  }

  editCanonForm(record:any){
    this.editCanonItem.emit(record);
    // this.router.navigate(['/verification/canon-form'],{
    //   state:{
    //     record:record,
    //     mode:'edit'
        
    //   }
    // })
  }

  viewReport(id:string){

  }

  deleteRecord(id:string){
     const deleteDialog = this.dialog.open(DeleteDialog, {
          disableClose: true,
          height: '200px',
          width: '500px',
          data: {
            modalTitle: 'Delete record',
            modalText: 'Are you sure that you want to delete the record?'
          }
        });
        deleteDialog.afterClosed().subscribe((value: any) => {
          console.log("Value returned:" + value);
          if (value == 'yes') {
            this.deleteCurrentCanonItem(id);
          }
        })
   
  }

  deleteCurrentCanonItem(id:string){
     this.verificationService.deleteCanonRecord(id)
    .subscribe({
      next:(data:any)=>{
        console.log(data);
      },
      error:(error:any)=>{
        console.log(error)
      }
    })
  }
}